import styled from 'styled-components';

import { StyledInput as CommonInput } from '~/src/common/components/Form/Input';
import Icon from '~/src/common/components/Icon';
import { COLORS, SPECIALS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';

export const Container = styled.div`
  isolation: isolate;
  position: relative;
  flex-grow: 1;
  z-index: 10;
`;

export const Menu = styled.ul<{ $hasResults: boolean }>`
  z-index: 10;
  position: absolute;
  overflow-y: auto;
  max-height: 200px;

  ${media.M`
    overflow: hidden;
    max-height: unset;
  `}

  width: 100%;
  margin-top: 8px;
  list-style-type: none;

  padding-left: 0;

  border-radius: 4px;
  background: ${COLORS.NEUTRAL_WHITE};
  border: 1px solid ${COLORS.NEUTRAL_STROKE};

  &:empty {
    display: none;
  }
`;

export const ResultFooterContainer = styled.div<{ $hasResult: boolean }>`
  line-height: 22px;
  padding: 10px 17px;

  border-top: ${p => (p.$hasResult ? `1px solid ${COLORS.NEUTRAL_STROKE}` : 'none')};
`;

export const Loading = styled.div`
  line-height: 22px;
  padding: 10px 17px;

  text-align: center;
  font-style: italic;
  color: ${COLORS.NEUTRAL_DISABLED};
`;

export const ErrorMessage = styled.div`
  line-height: 22px;

  position: absolute;
  top: 70px;
  right: 0;
  left: 0;

  padding: 10px 17px;
  border-radius: 4px;
  box-shadow: ${SPECIALS.SHADOW_NORMAL};

  background-color: ${COLORS.NEUTRAL_WHITE};
  text-align: center;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: -18px;
    left: 13px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent ${COLORS.NEUTRAL_WHITE} transparent;

    ${media.M`
      left: 24px;
    `}
  }
`;

export const ClearIcon = styled(Icon)`
  position: absolute;
  top: 17px;
  right: 7px;
  cursor: pointer;

  ${media.M`
    right: 16px;
  `}
`;

export const StyledInput = styled(CommonInput)<{ $hasLeftIcon: boolean }>`
  height: 56px;
  padding: ${({ $hasLeftIcon }) => ($hasLeftIcon ? '0 55px 0 48px' : '0 55px 0 16px')};

  border: solid 1px ${COLORS.NEUTRAL_STROKE};

  &:disabled {
    background-color: ${COLORS.GROUND_UPPERGROUND};
  }

  &::placeholder {
    font-size: 14px !important; /* applique pas la size si pas important */
    font-weight: 500;
    color: ${COLORS.NEUTRAL_DISABLED};
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  ${media.M<{ $hasLeftIcon: boolean }>`
    padding: ${({ $hasLeftIcon }) => ($hasLeftIcon ? '0 56px' : '0 16px')};

    &::placeholder {
      font-size: 16px;
    }
  `}
`;
